import React from 'react';
import {Shop} from 'interfaces';
import {CardMetricTypes} from 'components/Marketplace/ListingCard';
import {ListingCards, ListCardsLayoutsTypes} from 'components/Marketplace/ListingCards';
import {ShopEmpty} from '../ShopEmpty';

export interface ShopDisplayProps {
  shops: Shop[];
  loading?: boolean;
  countString: string;
  layout?: ListCardsLayoutsTypes;
  metricsToShow?: CardMetricTypes[];
}

export function ShopDisplay({
  shops,
  loading,
  countString,
  layout,
  metricsToShow,
}: ShopDisplayProps) {
  if (!shops.length) {
    return <ShopEmpty />;
  }

  return (
    <ListingCards
      shops={shops}
      loading={loading}
      countString={countString}
      layout={layout}
      metricsToShow={metricsToShow}
    />
  );
}
